const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedSportsbookProvider: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const sportsbookprovider = (state = initialState, action) => {
	switch (action.type) {
		case 'SPORTSBOOKPROVIDER_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'SPORTSBOOKPROVIDER_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'SPORTSBOOKPROVIDER_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'SPORTSBOOKPROVIDER_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'SPORTSBOOKPROVIDER_GET_CURRENT':
			return {
				...state,
				selectedSportsbookProvider: action.selectedSportsbookProvider,
			}
		case 'SPORTSBOOKPROVIDER_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default sportsbookprovider
